import React from 'react';

export const CapabilityProof = ({ t }) => {
  return (
    <section className="section-padding section-dark border-t-2 border-gray-900 relative overflow-hidden">
      {/* Strategic grid overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
          backgroundSize: '80px 80px'
        }} />
      </div>

      <div className="container mx-auto px-8 max-w-7xl relative z-10">
        {/* Header */}
        <div className="mb-20">
          <div className="border-l-2 border-white pl-6 mb-8">
            <p className="text-xs text-gray-400 uppercase tracking-[0.3em] font-medium">{t.capability.label}</p>
          </div>
          <h2 className="text-5xl md:text-7xl font-normal text-white mb-8 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t.capability.title}
          </h2>
          <p className="text-xl text-gray-400 font-light max-w-3xl">
            {t.capability.subtitle}
          </p>
        </div>

        {/* Metrics grid */}
        <div className="grid md:grid-cols-4 gap-8">
          {t.capability.metrics.map((metric, index) => (
            <div 
              key={index}
              className="border border-gray-800 p-8 relative bg-black/40 backdrop-blur-sm"
            >
              {/* Position marker */}
              <div className="absolute top-0 right-0 w-12 h-px bg-white opacity-30" />
              
              <div className="text-5xl font-normal text-white mb-4 tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {metric.value}
              </div>
              <div className="text-sm font-medium text-gray-300 mb-3 uppercase tracking-wider">
                {metric.label}
              </div>
              <p className="text-xs text-gray-500 font-light leading-relaxed">
                {metric.detail}
              </p>

              {/* Corner indicator */}
              <div className="absolute bottom-0 left-0 w-6 h-6 border-b border-l border-gray-700" />
            </div>
          ))}
        </div>

        {/* Additional capability note */}
        <div className="mt-16 border-t border-gray-800 pt-12">
          <p className="text-gray-500 font-light text-sm max-w-4xl">
            {t.capability.note}
          </p>
        </div>
      </div>
    </section>
  );
};
